import { useEffect } from "react";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { endPoints } from "../../config/end-points";
import useHttp from "../../hooks/use-http";
import { cuteToast } from "../UI/cute";
import Input from "../UI/Input";
import { access_specifier } from "../../config/app.config";

const AGENCY_CODES = ['6', '61', '62', '9'];

const UserForm = (props) => {
  const emailRef = useRef();
  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const passwordRef = useRef();
  var userDetail = props.userDetail;
  const [user, setUser] = useState({
    id: "",
    first_name: "",
    email: "",
    last_name: "",
  });

  const [access, setAccess] = useState("1,");
  const { sendRequest } = useHttp();
  const history = useHistory();

  useEffect(() => {
    if (userDetail) {
      setUser(userDetail);
      setAccess(userDetail.access);
    }
  }, [userDetail]);

  const userAccess = useSelector((state) => state.auth.access) || '';
  const userRoles = useSelector((state) => state.auth.roles);
  const isAgency = AGENCY_CODES.some(c => userAccess.includes(c)) && userRoles?.role_id !== 3;

  const default_access = {};
  delete access_specifier["5"];
  // Agency users can only assign FE access ("1")
  const app_all_access = isAgency ? { "1": access_specifier["1"] } : { ...default_access, ...access_specifier };

  const handleChange = (e, access_id) => {
    var new_Access = access.split(",");

    if (!access.includes("1")) {
      cuteToast({ type: "error", timer: 5000, title: "Primary Access Required" });
    }

    if (e.target.checked) {
      setAccess(access + access_id + ",");
    } else {
      var new_Access1 = new_Access.filter((a) => parseInt(a) !== parseInt(access_id));
      setAccess(new_Access1.toString());
    }
  };

  const checkAccess = (access1) => {
    if (access.includes(access1)) return true;
    return false;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!firstNameRef.current.val()) {
      firstNameRef.current.addClassName("form-control invalid");
      firstNameRef.current.focus();
      return false;
    } else {
      firstNameRef.current.addClassName("form-control");
    }

    if (!lastNameRef.current.val()) {
      lastNameRef.current.addClassName("form-control invalid");
      lastNameRef.current.focus();
      return false;
    } else {
      lastNameRef.current.addClassName("form-control");
    }

    if (!emailRef.current.val()) {
      emailRef.current.addClassName("form-control invalid");
      emailRef.current.focus();
      return false;
    } else {
      emailRef.current.addClassName("form-control");
    }

    if (!user.id)
      if (!passwordRef.current.val()) {
        passwordRef.current.addClassName("form-control invalid");
        passwordRef.current.focus();
        return false;
      } else {
        passwordRef.current.addClassName("form-control");
      }

    if (!access.includes("1")) {
      cuteToast({ type: "error", timer: 5000, title: "Primary Access Required" });
      return false;
    }

    const url = user.id
      ? endPoints.updateUser + "/" + user.id
      : endPoints.createUser;

    sendRequest(
      {
        url: url,
        method: "POST",
        body: {
          first_name: firstNameRef.current.val(),
          last_name: lastNameRef.current.val(),
          email: emailRef.current.val(),
          password: passwordRef.current.val(),
          access: access,
        },
      },
      (response) => {
        if (response.status === 202) {
          cuteToast({ type: "error", timer: 5000, title: response.message });
        } else {
          cuteToast({ type: "success", timer: 5000, title: response.message });
          if (!user.id) {
            setUser({ first_name: "", email: "", last_name: "" });
            history.push("/users/");
          }
        }
      }
    );
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="uc-card-body">
        {/* Personal Info Section */}
        <h6 className="uc-section-label">
          <i className="bi bi-person"></i> Personal Information
        </h6>
        <div className="uc-field-grid">
          <div className="uc-field">
            <label className="uc-field-label">
              First Name <span className="uc-required">*</span>
            </label>
            <Input
              type="text"
              placeholder="Enter first name"
              inputClass="form-control"
              value={user.first_name}
              ref={firstNameRef}
              onChange={(e) => setUser({ ...user, first_name: e.target.value })}
            />
          </div>

          <div className="uc-field">
            <label className="uc-field-label">
              Last Name <span className="uc-required">*</span>
            </label>
            <Input
              type="text"
              placeholder="Enter last name"
              inputClass="form-control"
              value={user.last_name}
              onChange={(e) => setUser({ ...user, last_name: e.target.value })}
              ref={lastNameRef}
            />
          </div>

          <div className="uc-field">
            <label className="uc-field-label">
              Email <span className="uc-required">*</span>
            </label>
            <Input
              type="text"
              placeholder="Enter email address"
              inputClass="form-control"
              ref={emailRef}
              value={user.email}
              onChange={(e) => setUser({ ...user, email: e.target.value })}
            />
          </div>

          <div className="uc-field">
            <label className="uc-field-label">
              Password {!user.id && <span className="uc-required">*</span>}
            </label>
            <Input
              type="password"
              placeholder={user.id ? "Leave blank to keep current" : "Enter password"}
              inputClass="form-control"
              ref={passwordRef}
            />
          </div>
        </div>

        {/* Access Section */}
        <h6 className="uc-section-label">
          <i className="bi bi-shield-check"></i> Access Permissions
        </h6>
        <div className="uc-access-grid">
          {Object.keys(app_all_access).map((access_id, index) => {
            const product_name = app_all_access[access_id];
            const isChecked = checkAccess(access_id);
            return (
              <label
                key={index}
                className={`uc-access-item${isChecked ? " uc-access-item--checked" : ""}`}
              >
                <input
                  type="checkbox"
                  className="uc-access-checkbox"
                  checked={isChecked}
                  onChange={(e) => handleChange(e, access_id)}
                />
                <span className="uc-access-label">{product_name}</span>
              </label>
            );
          })}
        </div>
      </div>

      {/* Footer */}
      <div className="uc-card-footer">
        <button type="reset" className="uc-btn-reset">Reset</button>
        <button type="submit" className="uc-btn-submit">
          <i className={`bi bi-${user.id ? "check-lg" : "plus-lg"}`}></i>
          {user.id ? "Update User" : "Create User"}
        </button>
      </div>
    </form>
  );
};

export default UserForm;
